// `onRender`/`onUpdate` are neutralised because CodePreview's default
// lifecycle rewrites the DOM with its `value` prop — chat feeds code in
// as markdown children via symbolize-markdown's `pre` → ChatCode mapping
// instead, and that subtree must survive each render.
export const ChatCode = {
  extends: 'CodePreview',
  maxWidth: '100%',
  theme: 'scene',
  background: 'black',
  color: 'white',
  onRender: () => {},
  onUpdate: () => {}
}

// Inline code — simple styled span for single-backtick `code` in markdown.
export const ChatInlineCode = {
  tag: 'code',
  fontFamily: 'monospace',
  fontSize: 'Y2',
  background: 'white.08',
  padding: '1px 4px',
  round: 'V',
  color: 'cyan'
}

export const ChatUL = {
  tag: 'ul',
  padding: 'V 0 V A',
  margin: 'V 0',
  flow: 'y',
  gap: 'V',
  listStyleType: 'disc',
  listStylePosition: 'outside',
  color: 'title'
}

export const ChatHr = {
  extends: 'Hr',
  margin: 'Z 0',
  background: 'line',
  height: '1px',
  border: 'none',
  opacity: '.5'
}

export const ChatOL = {
  tag: 'ol',
  padding: 'V 0 V A',
  margin: 'V 0',
  flow: 'y',
  gap: 'V',
  listStyleType: 'decimal',
  listStylePosition: 'outside',
  color: 'title'
}
